import { createContext, useEffect, useState } from 'react';
import { MerchantContextType } from './merchant-context.types';
import { PropsType } from '../../interfaces/ChildrenType';
import { MerchantInfo } from '../../interfaces/MerchantInfo';

const getInitialMerchantData = () => {
  const merchantData = sessionStorage.getItem('MerchantData');
  return merchantData ? JSON.parse(merchantData).product : null;
};

const getInitialIsNemuru = () => {
  const isNemuru = sessionStorage.getItem('isNemuru');
  return isNemuru ? JSON.parse(isNemuru) : null;
};

const getIsApp = () => {
  const isApp = sessionStorage.getItem('isApp');
  return isApp ? JSON.parse(isApp) : false;
};

const getIsPostDataMessages = () => {
  const isPostDataMessages = sessionStorage.getItem('isPostDataMessages');
  return isPostDataMessages ? JSON.parse(isPostDataMessages) : false;
};

const initialState: MerchantContextType = {
  merchantData: getInitialMerchantData(),
  isNemuru: getInitialIsNemuru(),
  isApp: getIsApp(),
  isPostDataMessages: getIsPostDataMessages(),
  setMerchantData: () => {},
  setIsNemuru: () => {},
  setIsApp: () => {},
  setIsPostDataMessages: () => {},
};

export const MerchantContext = createContext(initialState);

export const MerchantContextProvider: React.FC<PropsType> = ({ children }) => {
  const [merchantData, setMerchantData] = useState<
    MerchantInfo | null | undefined
  >(initialState.merchantData);

  const [isNemuru, setIsNemuru] = useState<boolean | null | undefined>(
    initialState.isNemuru
  );

  const [isApp, setIsApp] = useState<boolean>(initialState.isApp);

  const [isPostDataMessages, setIsPostDataMessages] = useState<boolean>(false);

  useEffect(() => {
    if (merchantData !== null && merchantData !== undefined) {
      sessionStorage.setItem(
        'MerchantData',
        JSON.stringify({ product: merchantData })
      );
    }
  }, [merchantData]);

  useEffect(() => {
    if (isNemuru !== null && isNemuru !== undefined) {
      sessionStorage.setItem('isNemuru', JSON.stringify(isNemuru));
    }
  }, [isNemuru]);

  useEffect(() => {
    sessionStorage.setItem('isApp', JSON.stringify(isApp));
  }, [isApp]);

  useEffect(() => {
    sessionStorage.setItem(
      'isPostDataMessages',
      JSON.stringify(isPostDataMessages)
    );
  }, [isPostDataMessages]);

  return (
    <MerchantContext.Provider
      value={{
        merchantData,
        setMerchantData,
        isNemuru,
        setIsNemuru,
        isApp,
        setIsApp,
        isPostDataMessages,
        setIsPostDataMessages,
      }}
    >
      {children}
    </MerchantContext.Provider>
  );
};
